// @flow
import * as React from "react";
import classes from "./StaticFieldText.scss";

type StaticFieldTextProps = {
  text: ?React.Node,
  defaultText: string
};

const StaticFieldText = ({ text, defaultText }: StaticFieldTextProps) => (
  <div className={classes.text}>{text || defaultText}</div>
);

StaticFieldText.defaultProps = {
  defaultText: "-"
};

export default StaticFieldText;
